var _path, _path2, _rect, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgInfoSquare = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  className: "info-square_svg__icon info-square_svg__icon-tabler info-square_svg__icon-tabler-info-square",
  width: 24,
  height: 24,
  strokeWidth: 1.5,
  stroke: "currentColor",
  fill: "none",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M0 0h24v24H0z",
  stroke: "none"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M12 8h.01"
})), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  x: 4,
  y: 4,
  width: 16,
  height: 16,
  rx: 2
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  d: "M11 12h1v4h1"
})));
export default SvgInfoSquare;